import { useEffect, useState } from 'react';
import {
  BatuInfo,
  CFECredentialsModal,
  RegistrationModal,
  TopNav,
  UXSurvey,
  CustomAuthenticator,
} from '../uiblocks';
import RequestBillForm from '../uiblocks/RequestBillForm';
import '../styles/Main.css';
import { TopToastMessage } from '../common';
import { FeedbackMessageType } from '../../models/types';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth';
import { useIntercom } from 'react-use-intercom';

const Main: React.FC = () => {
  const { update } = useIntercom();
  const { route } = useAuthenticator((context) => [context.route]);
  const [feedback, setFeedback] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [feedbackType, setFeedbackType] = useState<FeedbackMessageType>(
    FeedbackMessageType.SUCCESS
  );
  useEffect(() => {
    if (!document.body) return;
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      if (window.innerWidth < 770) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    });
    resizeObserver.observe(document.body);
    return () => resizeObserver.disconnect(); // clean up
  }, []);
  useEffect(() => {
    const updateEmail = async () => {
      const email: string = await fetchAuthSession().then(
        (session: AuthSession) => {
          const email = JSON.stringify(
            session.tokens?.idToken?.payload?.email
          ).replace(/['"]+/g, '');
          return email;
        }
      );
      update({ email: email });
    };
    if (route === 'authenticated') {
      console.log('Updating email');
      updateEmail();
    }
  }, [route]);
  //Catching submit events
  useEffect(() => {
    fetchAuthSession().then((session: AuthSession) => {
      console.log(session);
    });
    const listener = (event: any) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, []);
  const renderNavInForm = () => {
    if (!isMobile) {
      return <TopNav />;
    }
  };
  const renderNavInInfo = () => {
    if (isMobile && route === 'authenticated') {
      return <TopNav />;
    }
  };
  const renderForm = () => {
    if (route === 'authenticated') {
      return (
        <div className="main-form-container">
          {renderNavInForm()}
          <RequestBillForm
            setMessage={(message: string, type: FeedbackMessageType) => {
              setFeedbackType(type);
              setFeedback(message);
            }}
          />
        </div>
      );
    }
    return (
      <div className="main-form-container">
        <div className="auth-loom-video-container">
          <h3 className="auth-loom-video-instructions">
            ¡Entra a la nueva versión de Batu!
          </h3>
          <iframe
            title="loom-video"
            className="auth-loom-video-iframe"
            src="https://www.loom.com/embed/f10b3ded2b5c438f9c92b3863ff58db4?sid=20c16144-3699-4470-86fb-1a96b1acd8b7"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <CustomAuthenticator />
      </div>
    );
  };
  const renderInfo = () => {
    return (
      <div className="request-bill-info-main-container">
        {renderNavInInfo()}
        <BatuInfo />
      </div>
    );
  };
  return (
    <div className="main-container">
      <RegistrationModal />
      <CFECredentialsModal />
      <UXSurvey />
      <TopToastMessage
        toastText={feedback}
        toastType={feedbackType}
        resetMessage={() => setFeedback('')}
      />
      <div className="request-bill-container">
        {renderInfo()}
        {renderForm()}
      </div>
    </div>
  );
};
export { Main };
